export const COST_CENTRE_MESSAGES = {
  costCentreIdIsNull: 'La solicitud al servidor no puede estar vacía.',
  costCentreNotFound: 'No se ha encontrado el centro de costo seleccionado.',
  costCentreNoParent: 'El centro de costo de su tarjeta no tiene un padre asociado.',
  notAllowed:
    'No tiene autorización para visualizar los movimientos del centro de costo seleccionado.',
  notCardsOrChildren: 'Este centro de costo no tiene hijos ni tarjetas.',
  userNotAllowed: 'Su usuario no cuenta con los permisos necesarios para acceder a esta funcionalidad.',
  noAccessToCc: 'No tiene acceso para realizar una distribución en este centro de costo.',
};
